import { atom } from "recoil";

export const medicineUpdate = atom({
  key: "medicineUpdateState",
  default: false,
});

